import React from 'react';
import {connect} from "react-redux";
import {withRouter, useHistory} from 'react-router-dom'
import {logoutAction} from "~/redux/actions/auth";
import './header.scss';

import logoImg from '~/assets/logo-text-vertical.svg';
import profileImg from '~/assets/icons/profile.png';
import classnames from "classnames";
import { BurgerIcon, ProfileIcon } from '../../Icons/Icons';
import { setMyAccountPopupState, setPopupNavigationStatus } from '../../../redux/actions/general';
import TextTranslate from '../../TextTranslate/TextTranslate';
import LanguageSwitcher from '../../LanguageSwitcher/LanguageSwitcher';

const Header = ({userName = '', whiteBg, currentLanguage, languages, ...props}) => {
    const history = useHistory();

    const handleLogoutUser = () => {
        props.dispatch(logoutAction());
    };

    function showMyProfilePopup () {
        if(window.innerWidth < 768) {
            history.push('/myaccount')
        } else {
            props.dispatch(setMyAccountPopupState(true))
        }
    }

    function showPopupNavigation () {
        props.dispatch(setPopupNavigationStatus(true))
    }

    return (
        <div className={classnames({'header-wrap': true, 'white' : whiteBg} )}>
            <div className="container container-header">

                <div className="h-left-section">
                    <div className="logo">
                        <img src={logoImg}/>
                    </div>
                </div>

                <div className="h-right-section">
                    {!userName && props.auth.user && (
                        <div className="profile-info">
                            <div className="account" onClick={showMyProfilePopup}>
                                <ProfileIcon className="mr-3"/>
                                <span className="d-sm-block d-none">{props.auth.user?.full_name}</span>
                            </div>
                            <span className="mr-lg-4 mr-3 ml-lg-4 ml-3">|</span>
                            <a className="link d-none d-md-block" href="" onClick={handleLogoutUser}><TextTranslate name="word-logout" fallback="Log out"/></a>
                            <BurgerIcon classes="d-md-none d-block" onClick={showPopupNavigation}/>
                        </div>
                    )}

                    {userName && (
                        <div className="profile-info">
                            <img className="icon mr-3" src={profileImg}/>
                            <span>{userName}</span>
                        </div>
                    )}

                    <LanguageSwitcher />
                </div>

            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
    languages: state.translations.languages,
    auth: state.auth,
});

export default connect(mapStateToProps)(withRouter(Header));
